import { createContext, useContext, useEffect, useState } from "react";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
  GoogleAuthProvider,
  signInWithPopup,
} from "firebase/auth";

import { auth } from "../firebase";
//entrega los estados del usuario, si estoy logueado o signout

export const authContext = createContext();

//a continuacion un codigo para evitar los import useContext en cada pagina
export const useAuth = () => {
  const context = useContext(authContext);
  if (!context) throw new Error("_No hay auth provider");
  return context;
};
//fin codigo  evitar los import useContext en cada pagina.

export function AuthProvider({ children }) {
  /*const user = {
    login: true,
  };*/

  const [user, setUser] = useState(null); //null porq cuando se inicia la aplicacion no hay nadie logueado
  const [loading, setLoading] = useState(true);
  const signup = (email, password) =>
    createUserWithEmailAndPassword(auth, email, password);
  /*{ 
    console.log(email,password)
   }*/

  const login = async (email, password) => {
    const userCredentials = await signInWithEmailAndPassword(
      auth,
      email,
      password
    );
    console.log(userCredentials);
  };

  //se utiliza async await para obtener las propiedades del objeto que contiene las credenciales del usuario

  const logout = () => signOut(auth);

  const loginWithGoogle = () => {
    const googleProvider = new GoogleAuthProvider();
    return signInWithPopup(auth, googleProvider);
  };

  //si hay user se pasa el estado a  authprovider
  useEffect(() => {
    const unsuscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser); //console.log(currentUser)
      setLoading(false);
    });

    return () => unsuscribe();
  }, []);

  return (
    <authContext.Provider
      value={{ signup, login, user, logout, loading, loginWithGoogle }}
    >
      {children}
    </authContext.Provider>
  );
}
